import { Component, EventEmitter, Input, Output } from '@angular/core';
import { VistaTelefono } from '../cuentas-contrato-borrador';

/**
 * El teléfono: lo que vería el cliente en la app. Es un componente de pura presentación; el padre calcula la vista
 * (cuentas-contrato-borrador.ts, `vistaTelefono`) con el borrador y la vuelve a calcular con cada cambio.
 */
@Component({
  selector: 'app-cuentas-contrato-telefono',
  templateUrl: './cuentas-contrato-telefono.component.html',
  styleUrls: ['./cuentas-contrato-telefono.component.css']
})
export class CuentasContratoTelefonoComponent {
  @Input() vista: VistaTelefono = { opciones: [], reordenada: false, perfil: null };
  @Input() modo: 'hoy' | 'borrador' = 'borrador';
  @Input() hayCambios = false;
  @Output() modoChange = new EventEmitter<'hoy' | 'borrador'>();
}
